export default "__VITE_ASSET__yz3TQTCG__"